(function () {
  var root = document.documentElement;
  if (root.getAttribute('data-cc-focus') === '1') return;
  root.setAttribute('data-cc-focus', '1');

  function isBanner(el) {
    return el.id && el.id.indexOf('__image_banner_') !== -1 && el.querySelector('.banner');
  }

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    /* erste Gruppe von mindestens 2 Bild-Bannern direkt untereinander */
    var secs = [], run = [], kids = main.children;
    for (var k = 0; k <= kids.length; k++) {
      if (k < kids.length && isBanner(kids[k])) { run.push(kids[k]); continue; }
      if (run.length >= 2) { secs = run; break; }
      run = [];
    }
    if (secs.length < 2) return;

    /* Inhalte aus den Bannern lesen */
    var items = secs.map(function (sec) {
      var img = sec.querySelector('.banner__media img');
      var h = sec.querySelector('.banner__heading');
      var t = sec.querySelector('.banner__text');
      var b = sec.querySelector('.banner__buttons');
      return {
        src: img ? (img.getAttribute('src') || '') : '',
        srcset: img ? (img.getAttribute('srcset') || '') : '',
        alt: img ? (img.getAttribute('alt') || '') : '',
        heading: h ? h.innerHTML.trim() : '',
        text: t ? t.innerHTML.trim() : '',
        buttons: b && b.textContent.trim() ? b.outerHTML : ''
      };
    });

    function copy(it) {
      return (it.heading ? '<h2>' + it.heading + '</h2>' : '') + it.text + it.buttons;
    }

    var wrap = document.createElement('div');
    wrap.className = 'shopify-section cc-focus-sec';
    var html = '<div class="cc-focus"><div class="cc-focus__inner page-width">';
    html += '<div class="cc-focus__text"><div class="cc-focus__panel"><div class="cc-focus__steps" aria-hidden="true">';
    items.forEach(function () { html += '<span></span>'; });
    html += '</div><div class="cc-focus__items">';
    items.forEach(function (it, i) { html += '<div class="cc-focus__item" data-i="' + i + '">' + copy(it) + '</div>'; });
    html += '</div></div></div><div class="cc-focus__media">';
    items.forEach(function (it, i) {
      html += '<div class="cc-focus__step" data-i="' + i + '"><figure class="cc-focus__fig">' +
        '<img src="' + it.src + '"' + (it.srcset ? ' srcset="' + it.srcset + '" sizes="(min-width: 990px) 58vw, 100vw"' : '') +
        ' alt="' + it.alt.replace(/"/g, '&quot;') + '" loading="lazy"></figure>' +
        '<div class="cc-focus__cap">' + copy(it) + '</div></div>';
    });
    html += '</div></div></div>';
    wrap.innerHTML = html;

    main.insertBefore(wrap, secs[secs.length - 1].nextSibling);
    secs.forEach(function (sec) { sec.parentNode.removeChild(sec); });

    var steps = Array.prototype.slice.call(wrap.querySelectorAll('.cc-focus__step'));
    var texts = Array.prototype.slice.call(wrap.querySelectorAll('.cc-focus__item'));
    var dots = Array.prototype.slice.call(wrap.querySelectorAll('.cc-focus__steps span'));
    var header = document.querySelector('.section-header');
    var active = -1, ticking = false;

    function setActive(i) {
      if (i === active) return;
      active = i;
      wrap.querySelector('.cc-focus').classList.toggle('is-odd', i % 2 === 1);
      [steps, texts, dots].forEach(function (list) {
        list.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
      });
    }

    function measure() {
      var sticky = header && (header.classList.contains('shopify-section-header-sticky') ||
        window.getComputedStyle(header).position === 'sticky');
      root.style.setProperty('--cc-focus-top', (sticky ? Math.round(header.offsetHeight) : 0) + 'px');
    }

    function update() {
      ticking = false;
      var mid = window.innerHeight / 2, best = 0, bestD = Infinity;
      steps.forEach(function (s, i) {
        var r = s.querySelector('.cc-focus__fig').getBoundingClientRect();
        var d = Math.abs(r.top + r.height / 2 - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      setActive(best);
    }
    function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

    measure();
    setActive(0);
    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () { measure(); schedule(); }, { passive: true });

    /* Handy: Textkarten gleiten beim Erscheinen hoch */
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      root.classList.add('cc-focus-anim');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.25 });
      steps.forEach(function (s) { io.observe(s); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
